import React, { useState } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import LocalizedText from '@LocalizedText';

import FileInput from '@components/buttons/file-input-btn/FileInput';
import './DropZone.scss';

const DropZone = ({ fileBtnLocKey, handleFileSelect, resetSelectedFile, supportedTypes = '', dropZoneTitle, multiple, disabled }) => {
  const [isDragProcess, setIsDragProcess] = useState(false);
  const [isDropped, setIsDropped] = useState(false);

  const handleFileDrop = ({ dataTransfer }) => {
    if (disabled) return;

    setIsDropped(true);
    setIsDragProcess(false);
    const files = Array.from(dataTransfer.files) || [];

    if (!files.length) return;

    handleFileSelect(multiple ? files : files[0]);
  };

  return (
    <div
      id="upload-drop-zone"
      onDrop={handleFileDrop}
      onDragEnter={() => {
        if (disabled) return;
        resetSelectedFile();
        setIsDropped(false);
      }}
      onDragOver={() => !disabled && setIsDragProcess(true)}
      onDragLeave={() => setIsDragProcess(false)}
      className={classnames({ 'drag-over': isDragProcess, dropped: isDropped, disabled })}
      aria-label={dropZoneTitle}
      aria-disabled={disabled}
    >
      <div className="drop-zone-title">{dropZoneTitle}</div>
      <LocalizedText id="qau-upload-or-text" />
      <FileInput
        handleFileSelect={file => {
          resetSelectedFile();
          handleFileSelect(file);
        }}
        locKey={fileBtnLocKey}
        accept={supportedTypes}
        multiple={multiple}
        disabled={disabled}
      />
    </div>
  );
};

DropZone.propTypes = {
  fileBtnLocKey: PropTypes.string,
  supportedTypes: PropTypes.string,
  handleFileSelect: PropTypes.func.isRequired,
  resetSelectedFile: PropTypes.func.isRequired,
  dropZoneTitle: PropTypes.string,
  multiple: PropTypes.bool,
  disabled: PropTypes.bool,
};

export default DropZone;
